import { StatelessComponent, ComponentType } from 'react'
import { InternalPageRedirect } from 'components/features/pfm/InternalPageRedirect/InternalPageRedirect'

function internal<TProps extends {}> (Component: ComponentType<TProps>) {
  const InternalWrapper: StatelessComponent<TProps> = (props) => (
    <InternalPageRedirect>
      <Component { ...props } />
    </InternalPageRedirect>
  )

  return InternalWrapper
}

export default internal
